const React = require('react')
const { useContext, createContext, useState } = require('react')
const { NETWORK_CONFIG } = require('@configs')

const NetworkConfigState = () => {
    const [currentNetwork, setCurrentNetwork] = useState({
        name: 'agd',
        data: NETWORK_CONFIG.agd
    })

    const switchNetwork = targetNetwork => {
        if (!targetNetwork) {
            setCurrentNetwork({
                name: 'agd',
                data: NETWORK_CONFIG.agd
            })
        }
        if (targetNetwork != currentNetwork.name) {
            Object.keys(NETWORK_CONFIG).forEach(name => {
                if (NETWORK_CONFIG[name].shortName == targetNetwork) {
                    setCurrentNetwork({
                        name: targetNetwork,
                        data: NETWORK_CONFIG[name]
                    })
                }
            })
        }
        return
    }

    return {
        network: currentNetwork,
        switchNetwork
    }
}

const NetworkConfigContext = createContext()
const useNetworkConfig = () => useContext(NetworkConfigContext)

const NetworkConfigProvider = ({ children }) => {
    return <NetworkConfigContext.Provider value={NetworkConfigState()}>{children}</NetworkConfigContext.Provider>
}

module.exports = {
    useNetworkConfig,
    NetworkConfigProvider
}
